import {BasicPopout} from '../popout_card/popouts/basic_popout'
import {ChatButton} from '../eitje_button/buttons'

export const ChatPopout = props => {
	return <BasicPopout {...props} buttons={<ChatButton colorSet="color-bordered-outline" />} />
}
